import { deploymentService } from "fleet/service/deployment";
import { createApiSaga } from "redux-store/api-sagas";

import { LOAD_DEPLOYMENTS_FAILURE, LOAD_DEPLOYMENTS_SUCCESS } from "./actions";

const reloadDeploymentsSaga = createApiSaga({
  service: deploymentService.load,
  serviceName: "deploymentService.load",
  successAction: LOAD_DEPLOYMENTS_SUCCESS,
  failureAction: LOAD_DEPLOYMENTS_FAILURE,
  reload: true,
});

const deploymentsSagas = [reloadDeploymentsSaga()];

export { deploymentsSagas };
